import { render, staticRenderFns } from "./costDetails.vue?vue&type=template&id=129f0434&scoped=true"
import script from "./costDetails.vue?vue&type=script&lang=js"
export * from "./costDetails.vue?vue&type=script&lang=js"
import style0 from "./costDetails.vue?vue&type=style&index=0&id=129f0434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f0434",
  null
  
)

export default component.exports